import { v4 } from 'uuid';
import { customAlphabet } from 'nanoid';
// remove `_` and `-` from the list, for more human readable strings
const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 12);

export type UID = string;
export const Empty: UID = '(empty)';

export function UID(): UID {
  return v4();
}

// WithID associates a data type with a UID.
export type WithID<T> = {
  id: UID;
} & T;

export function alphanumericUID(): UID {
  return nanoid();
}
